import { render, staticRenderFns } from "./TemplateArchive.vue?vue&type=template&id=5345cee0"
import script from "./TemplateArchive.vue?vue&type=script&lang=js"
export * from "./TemplateArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports